<template>
    <div>
      <div>Github Contributions today: <b>{{github_today}}</b><b-spinner small Label="Spinnng" v-if="github_today === ''"/></div>
      <div>Github Contributions so far this year: <b>{{github_ytd}}</b><b-spinner small Label="Spinnng" v-if="github_ytd === ''"/></div>
      <br>
      <div>HackerNews Karma: <b>{{hn_karma}}</b><b-spinner small Label="Spinnng" v-if="hn_karma === ''"/></div>
      <br>
      <div>Location: <b>{{location}}</b><b-spinner small Label="Spinnng" v-if="location === ''"/></div>
      <br>
      <div>Currently Reading: <a :href="book_link"><b>{{book}}</b></a><b-spinner small Label="Spinnng" v-if="location === ''"/></div>
      <br>
      <p class="quiet">(All stats are updated live)</p>
    </div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'Stats',
  data () {
    return {
      github_ytd: '',
      github_today: '',
      hn_karma: '',
      location: '',
      book: '',
      book_link: ''
    }
  },
  methods : {
    get_github: function (T) {
      var today = new Date();
      var today_date = today.getFullYear()+'-'+("0" + (today.getMonth()+1)).substr(-2)+'-'+("0" + (today.getDate())).substr(-2);
      axios.get('https://github-contributions.now.sh/api/v1/SamWheating')
      .then( function (response) {
        T.github_ytd = response.data.years[0].total
        T.github_today = response.data.contributions.find(o => o.date === today_date).count
      }
    )
    },
    get_hn: function(T) {
      axios.get('https://hacker-news.firebaseio.com/v0/user/yung_donair.json')
      .then( function (response) {
        T.hn_karma = response.data.karma
      }
      )
    },
    get_stats: function(T) {
      axios.get('https://statsserver-go-7xudikxqwq-uc.a.run.app/stats')
      .then( function (response) {
        T.location = response.data.Location
        T.book = response.data.Book
        T.book_link = response.data.Link
      }
      )
    }
  },
  mounted: function () {
    this.get_github(this)
    this.get_hn(this)
    this.get_stats(this)
  }
}
</script>

<style>

.quiet {
  color: #8c9eB0
}

</style>
